function nextTick() {
  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}

async function getStickyHeaderHeight(stickyHeader) {
  // Render sticky header offscreen to get its height

  const stickyHeaderHeight = stickyHeader.offsetHeight;
  return stickyHeaderHeight;
}

(async () => {
  const header = document.querySelector(".header");


  const headerHeight = header.offsetHeight;
  header.style.setProperty("--header-height", headerHeight - 12 + "px");

  await nextTick();
  const stickyHeader = document.querySelector("body > .main_nav_wrapper");
  const stickyHeaderHeight = await getStickyHeaderHeight(stickyHeader);
  stickyHeader.style.setProperty("--header-height", stickyHeaderHeight + "px");

  document.body.classList.add("header-size-calculated");
})();
